module.exports = __webpack_public_path__ + "media/images/lb/796-705de6a4578cb6ee16003b5787556fea.svg";